import React from 'react';
import styles from './styles.module.scss';

export interface FormSectionProps {
  title?: string;
  hint?: string;
  dividerAfter?: boolean;
  children: React.ReactNode;
}

export function FormSection({
  title,
  hint,
  dividerAfter = false,
  children,
}: FormSectionProps): React.ReactElement {
  return (
    <>
      <section className={styles.section}>
        {title !== null && title !== '' && <h2 className={styles.sectionTitle}>{title}</h2>}
        {hint !== null && hint !== '' && <p className={styles.sectionHint}>{hint}</p>}
        {children}
      </section>
      {dividerAfter && <hr className={styles.sectionDivider} />}
    </>
  );
}
